import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

import { Field, Facility } from '@app/_models/facilities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FacilityService {
  private facility: Facility;
  private fields: Field[] = [];

  constructor(private http: HttpClient) {}

  getFacility(id): Observable<Facility> {
    return this.http.get<Facility>(`${environment.apiUrl}/facilities/${id}/`);
  }

  getFields(facility_id): Promise<Field[]> {
    // Return the fields corresponding to the current facility
    return new Promise((resolve, reject) => {
      this.getFacility(facility_id).subscribe(data => {
        this.facility = data;
        this.facility.h_apertura = 8;
        this.facility.h_cierre = 24;
        resolve(data.fields as Field[]);
      });
    });
  }
}
